import { render, staticRenderFns } from "./Reciepe.vue?vue&type=template&id=18ec2534&"
import script from "./Reciepe.vue?vue&type=script&lang=js&"
export * from "./Reciepe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports